import { isEmpty } from 'lodash-es'

export function getOpenKeys(sidebarsSchema, location) {
  if (!sidebarsSchema) {
    return null
  }
  const { sidebars, alwaysOpenKeys, menu } = sidebarsSchema
  let currentSection = []
  for (const [, section] of sidebars.entries()) {
    if (section.items) {
      for (const item of section.items) {
        const link = `${item.link}/${menu}`
        if (link === location.pathname) {
          currentSection = section.titleItem?.eventKey ? [section.titleItem.eventKey] : []
          break
        }
      }

      if (!isEmpty(currentSection)) {
        break
      }
    }
  }

  return [...alwaysOpenKeys, ...currentSection]
}
